import { IonButton, IonContent } from "@ionic/react";
interface Props {
  setShowModal: Function;
}
const CodeResentModal: React.FC<Props> = ({ setShowModal }) => {
  return (
    <IonContent placeholder={undefined}>
      <div className="code-resent-modal-custom">
        <h2>Code Resent</h2>
        <h4>
          Make sure to check your spam / trash folders as well depending on your
          organization’s email filter setup.
        </h4>
        <IonButton
          className="generic-btn generic-btn-outline"
          onClick={() => setShowModal(false)} placeholder={undefined}        >
          Close
        </IonButton>
      </div>
    </IonContent>
  );
};
export default CodeResentModal;